module.exports = __webpack_public_path__ + "static/img/img15.f551e1c1.png";